module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/plan01_point-939256977c60b9387d0618910170ad58.jpg";